import React from "react";
import stateprops from "../../assets/state-props.png";

const Presentation = () => (
  <section id="state-props-intro">
    <img data-src={stateprops} alt="Jest" style={{ height: "auto", width: "auto" }} />
  </section>
);

export default Presentation;
